import { render, staticRenderFns } from "./main.vue?vue&type=template&id=f8666c8a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8666c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8666c8a')) {
      api.createRecord('f8666c8a', component.options)
    } else {
      api.reload('f8666c8a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=f8666c8a&scoped=true", function () {
      api.rerender('f8666c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/manager/main.vue"
export default component.exports